import * as React from "react";
export default (props: React.SVGProps<SVGSVGElement>) => (
  <svg {...props} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M5.615 11h8.199v2H5.642l3.23 3.23-1.415 1.414L1.8 11.987 7.457 6.33 8.87 7.744 5.615 11zm16.199 0v2h-2v-2h2zm-3 0v2h-4v-2h4z"
    />
  </svg>
);
